import { NgModule } from '@angular/core';
import { IfSupportsProductsDirective } from './if-supports-products.directive';

@NgModule({
    imports: [IfSupportsProductsDirective],
    exports: [IfSupportsProductsDirective],
})
export class IfSupportsProductsDirectiveModule {}
